import { useEffect, useState } from "react";
import { Select } from "@mantine/core";
import { useAuthUser } from "react-auth-kit";
import { useServerApi } from "../hooks/userServerApi";
import {
  getStoredCompanyId,
  getWorkspaceCompanies,
  pickWorkspaceId,
  setStoredCompanyId,
  shouldShowCompanyWorkspaceSwitcher,
} from "../helpers/companyWorkspace";

const CompanyWorkspaceSwitcher = () => {
  const auth = useAuthUser();
  const [api] = useServerApi();
  const [companies, setCompanies] = useState([]);
  const [value, setValue] = useState(getStoredCompanyId());

  useEffect(() => {
    if (!auth()?.id) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const result = await api.search({
          apiEntity: "company",
          pageSize: 100,
          currentPage: 1,
          sort: { by: "code", order: "ascend" },
          byAggregation: false,
        });
        if (cancelled) return;
        const docs = getWorkspaceCompanies(result?.docs || []);
        setCompanies(docs);
        const picked = pickWorkspaceId(docs, getStoredCompanyId());
        if (picked) {
          if (picked !== getStoredCompanyId()) setStoredCompanyId(picked);
          setValue(picked);
        } else {
          setStoredCompanyId("");
          setValue("");
        }
      } catch (error) {
        if (!cancelled) {
          setCompanies([]);
          setStoredCompanyId("");
          setValue("");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [auth()?.id]);

  if (!shouldShowCompanyWorkspaceSwitcher(companies)) return null;

  return (
    <Select
      size="xs"
      mt="sm"
      label="Workspace"
      placeholder="Company"
      value={
        companies.some((company) => company._id === value)
          ? value
          : pickWorkspaceId(companies, value) || null
      }
      data={companies.map((company) => ({
        value: company._id,
        label: company.name || company.code,
      }))}
      onChange={(next) => {
        if (!next) return;
        setStoredCompanyId(next);
        setValue(next);
        window.location.reload();
      }}
      withinPortal
    />
  );
};

export default CompanyWorkspaceSwitcher;
